import { connect } from "react-redux";
import { Routes, RoutesProps } from "./routes";
import { Store } from "Store/index";

type StateProps = Pick<RoutesProps, "routes">;

function mapStateToProps(state: Store): StateProps {
  return {
    routes: state.application.routes.map(route => route.path)
  };
}

const routesHOC = connect(mapStateToProps, () => ({}))(Routes);
export { routesHOC as RoutesHOC };
